var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.184 37.941-9.364-9.364a14.56 14.56 0 0 0 2.39-8.003c0-8.083-6.553-14.636-14.636-14.636S5.938 12.491 5.938 20.574 12.49 35.21 20.574 35.21a14.56 14.56 0 0 0 8.004-2.391l9.364 9.364zM8.937 20.574c0-6.417 5.22-11.636 11.636-11.636s11.636 5.22 11.636 11.636-5.22 11.636-11.636 11.636S8.937 26.99 8.937 20.574"
  })))));
};
export default SvgSearch;